import axios from 'axios';

import { getSchedulingServerURL } from '../../HarverPages/shared/helper';

interface OpenInviteInput {
    candidate: {
        firstName: string;
        lastName: string;
        email: string;
    };
}

interface ValidatableOpenInviteInterviewSettings {
    organizationId: string;
    organizationName: string;
}

export async function createOpenInvite(openInviteId: string, payload: OpenInviteInput, recaptchaToken = '') {
    await axios.post(`${getSchedulingServerURL()}/interview/invite/${openInviteId}`, payload, {
        headers: {
            recaptchaToken,
        },
    });
}

export async function getOpenInviteDetails(openInviteId: string): Promise<ValidatableOpenInviteInterviewSettings> {
    const { data } = await axios.get(`${getSchedulingServerURL()}/interview/invite/${openInviteId}`);
    return data;
}

//TODO - will remove after removing feature toggle - schedulingOpenInviteReCaptcha
export async function getHpAccountIdForOpenInvite(organizationId: string): Promise<string | undefined> {
    const { data } = await axios.get(`${getSchedulingServerURL()}/interview/invite/organization/${organizationId}`);
    return data;
}
